export const onValidatePinChange = (pin: string) => {
  sessionStorage.setItem('pin', pin);

  return {
    message: '',
    state: 'ok',
  };
};
